import { render, staticRenderFns } from "./groups-table.vue?vue&type=template&id=8f951270&scoped=true&"
import script from "./groups-table.vue?vue&type=script&lang=js&"
export * from "./groups-table.vue?vue&type=script&lang=js&"
import style0 from "./groups-table.vue?vue&type=style&index=0&id=8f951270&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f951270",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VDataTable,VIcon,VRow,VSpacer})
